import $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { CustomEase } from "gsap/CustomEase";

const SmoothScroll = () => {
  gsap.registerPlugin(ScrollToPlugin, CustomEase);

  $(document).on('click', '.js-scroll', function(e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const delay = $(this).data('delay') ? parseInt($(this).data('delay')) : 0;
    const addPosition = $(this).data('position') ? parseInt($(this).data('position')) : 0;
    setTimeout(() => {
    const target = $(href);
    const position = target.offset().top;
    const shift = window.innerWidth < 992 ? 100 : 160 + addPosition;

    lenis.scrollTo(position - shift, {
      duration: 0.6,
    });
    // gsap.to(window, {
    //   duration: 0.6,
    //   scrollTo: { y: position - shift },
    //   ease: CustomEase.create("custom", "M0,0 C0.29,0 0.294,0.018 0.365,0.103 0.434,0.186 0.466,0.362 0.498,0.502 0.518,0.592 0.525,0.853 0.615,0.924 0.694,0.987 0.704,1 1,1 "),
    // });
    // window.scrollTo({ top: position - shift, behavior: 'smooth' });
    // $('html, body').animate({
    //   scrollTop: position - shift,
    // }, 500);
  }, delay);
});

}

export default SmoothScroll;